import Private from './Private/Private'
import Public from './Public/Public'
import FormLay from './FormLay/FormLay'

export const LayoutPrivate = Private
export const LayoutPublic = Public
export const FormLayout = FormLay
